// extracted by mini-css-extract-plugin
export default {"wrap":"suggestInput_wrap__POiur","menu":"suggestInput_menu__mDuZ1","item":"suggestInput_item__JPnRj"};